import { mapGetters, mapActions } from 'vuex';
import Cookies from 'js-cookie';

//

var EVENT_ACCEPT = 'accept';
var EVENT_DENY = 'deny';

var script = {
    computed: Object.assign({}, mapGetters('cookie', [
            'dismissed', 'denied', 'accepted'
        ])),
    methods: Object.assign({}, {onAccept: function onAccept() {
            this.$emit(EVENT_ACCEPT);
            this.accept();
        },

        onDeny: function onDeny() {
            this.$emit(EVENT_DENY);
            this.deny();
        }},

        mapActions('cookie', [
            'deny', 'accept'
        ]))
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function () {
      style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

var normalizeComponent_1 = normalizeComponent;

var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
  return function (id, style) {
    return addStyle(id, style);
  };
}
var HEAD;
var styles = {};

function addStyle(id, css) {
  var group = isOldIE ? css.media || 'default' : id;
  var style = styles[group] || (styles[group] = {
    ids: new Set(),
    styles: []
  });

  if (!style.ids.has(id)) {
    style.ids.add(id);
    var code = css.source;

    if (css.map) {
      // https://developer.chrome.com/devtools/docs/javascript-debugging
      // this makes source maps inside style tags work properly in Chrome
      code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'; // http://stackoverflow.com/a/26603875

      code += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) + ' */';
    }

    if (!style.element) {
      style.element = document.createElement('style');
      style.element.type = 'text/css';
      if (css.media) { style.element.setAttribute('media', css.media); }

      if (HEAD === undefined) {
        HEAD = document.head || document.getElementsByTagName('head')[0];
      }

      HEAD.appendChild(style.element);
    }

    if ('styleSheet' in style.element) {
      style.styles.push(code);
      style.element.styleSheet.cssText = style.styles.filter(Boolean).join('\n');
    } else {
      var index = style.ids.size - 1;
      var textNode = document.createTextNode(code);
      var nodes = style.element.childNodes;
      if (nodes[index]) { style.element.removeChild(nodes[index]); }
      if (nodes.length) { style.element.insertBefore(textNode, nodes[index]); }else { style.element.appendChild(textNode); }
    }
  }
}

var browser = createInjector;

/* script */
var __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return !_vm.dismissed
    ? _c("div", { staticClass: "cookiebar" }, [
        _c("div", { staticClass: "cookiebar__body" }, [
          _vm.$slots.header
            ? _c(
                "div",
                { staticClass: "cookiebar__header" },
                [_vm._t("header")],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$slots.message
            ? _c(
                "div",
                { staticClass: "cookiebar__message" },
                [_vm._t("message")],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "cookiebar__buttons" }, [
            _c(
              "a",
              {
                staticClass: "cookiebar__button cookiebar__button-accept",
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault();
                    return _vm.onAccept($event)
                  }
                }
              },
              [_vm._t("acceptText", [_vm._v("Accept")])],
              2
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "cookiebar__button cookiebar__button-dismiss",
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault();
                    return _vm.onDeny($event)
                  }
                }
              },
              [_vm._t("denyText", [_vm._v("I do not accept")])],
              2
            )
          ])
        ])
      ])
    : _vm._e()
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  var __vue_inject_styles__ = function (inject) {
    if (!inject) { return }
    inject("data-v-5f500ede_0", { source: "/**\n * Vue-Cookiebar\n *\n * @author    Ezra Pool <ezra@digitalnatives.nl>\n * @copyright Digital Natives (c) 2018\n */\n[v-cloak] {\n  display: none;\n}\n.cookiebar {\n  /* Positioning */\n  position: fixed;\n  bottom: 0;\n  z-index: 4;\n  /* Box-model */\n  height: auto;\n  width: 100%;\n  padding: 1rem 0;\n  /* Visual */\n  background-color: #fff;\n  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.3);\n}\n.cookiebar__body {\n  /*.clearfix();\n    .page-container();*/\n}\n.cookiebar__header,\n.cookiebar__message,\n.cookiebar__buttons {\n  width: 100%;\n  margin-bottom: 0.5rem;\n  /*@media @q-sm-min {\n        float: left;\n    }*/\n}\n.cookiebar__header,\n.cookiebar__message {\n  position: relative;\n}\n.cookiebar__header {\n  margin-bottom: 1rem;\n}\n.cookiebar__buttons {\n  width: 13rem;\n  padding-left: 1rem;\n  text-align: right;\n}\n.cookiebar__button {\n  display: inline-block;\n  margin: 0.3125rem 0 0;\n  text-align: center;\n}\n.cookiebar__button-accept {\n  color: #fff;\n}\n", map: undefined, media: undefined });

  };
  /* scoped */
  var __vue_scope_id__ = undefined;
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* style inject SSR */
  

  
  var Cookiebar = normalizeComponent_1(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    browser,
    undefined
  );

function state () {
    return {
        denied: undefined,
        dismissed: undefined
    };
}

var getters = {
    dismissed: function (ref) {
        var dismissed = ref.dismissed;

        return (dismissed !== undefined) ? dismissed : Cookies.get('cookie-dismissed') === '1';
},
    denied: function (ref) {
        var denied = ref.denied;

        return (denied !== undefined) ? denied : Cookies.get('cookie-disabled') !== '0';
},
    accepted: function (ref, ref$1) {
        var denied = ref$1.denied;

        return (denied !== undefined) ? !denied : Cookies.get('cookie-disabled') !== '1';
}
};

var DISMISS = 'DISMISS';
var DENY = 'DENY';
var ACCEPT = 'ACCEPT';

var actions = {
    dismiss: function dismiss(ref) {
        var commit = ref.commit;

        Cookies.set('cookie-dismissed', '1', {
            expires: 365
        });

        commit(DISMISS);
    },
    accept: function accept(ref) {
        var commit = ref.commit;
        var dispatch = ref.dispatch;

        Cookies.set('cookie-disabled', '0', {
            expires: 365
        });

        commit(ACCEPT);
        dispatch('dismiss');
    },
    deny: function deny(ref) {
        var commit = ref.commit;
        var dispatch = ref.dispatch;

        Cookies.set('cookie-disabled', '1', {
            expires: 365
        });

        commit(DENY);
        dispatch('dismiss');
    }
};

var obj;

var mutations = ( obj = {}, obj[DISMISS] = function (state) {
        state.dismissed = true;
    }, obj[DENY] = function (state) {
        state.denied = true;
    }, obj[ACCEPT] = function (state) {
        state.denied = false;
    }, obj );

var module = {
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
};

export default Cookiebar;
export { Cookiebar, module as store };
